import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorDescriptionHash } from '../constants/errorDescriptionsFromBE';
import { BuildProps } from '@app/origami-api/build-props';
import { Locale } from '@app/origami-api/constants/default-locales';

@Injectable()
export class ErrorDescriptionService {
  private readonly availableLocales = Object.values(Locale);

  getErrorDescriptions(locale: string): Observable<ErrorDescriptionHash> {
    if (!this.availableLocales.includes(locale as Locale)) {
      locale = Locale.en_US; // falling back to default one
    }
    // SyntaxError: JSON.parse: unexpected character at line 1 column 1 of the JSON data
    return from(
      new Promise((resolve, reject) => {
        const req = new XMLHttpRequest();
        req.addEventListener('load', () => {
          if (req.status === 200) {
            try {
              const res = req.responseText ? JSON.parse(req.responseText) : {};
              resolve(res);
            } catch (error) {
              reject(new Error('Failed to parse JSON response: ' + error.message));
            }
          } else {
            reject(new Error('Request failed with status: ' + req.status));
          }
        });

        req.addEventListener('error', () => {
          reject(new Error('Network error occurred'));
        });

        req.open('GET', `${BuildProps.origin}error-codes?loc=${locale}&nocache=${Date.now()}`);
        req.send();
      }),
    ).pipe(
      map((res) => res as ErrorDescriptionHash),
      catchError((error) => {
        // console.error('Error fetching error descriptions:', error);
        return of({});
      }),
    );
  }
}
